import { GenerateId } from 'jss';

export const generateClassName = (prefix = 'mt'): GenerateId => {
  let counter = 0;

  // eslint-disable-next-line no-plusplus
  return (rule) => `${prefix}-${rule.key}-${counter++}`;
};
